'use strict';
(()=>{
const wire=root=>{
root.querySelectorAll('[data-native-announcements]').forEach(panel=>{if(panel.dataset.wired)return;panel.dataset.wired='true';const slides=[...panel.querySelectorAll('[data-native-announcement]')];let current=0;const show=index=>{if(!slides.length)return;current=(index+slides.length)%slides.length;slides.forEach((slide,i)=>{slide.classList.toggle('is-active',i===current);slide.setAttribute('aria-hidden',String(i!==current));slide.inert=i!==current;});};panel.querySelectorAll('[data-native-announcement-step]').forEach(button=>button.addEventListener('click',()=>show(current+Number(button.dataset.nativeAnnouncementStep))));panel.addEventListener('shopify:block:select',event=>{const index=slides.indexOf(event.target);if(index>=0)show(index);});});
root.querySelectorAll('[data-variant-navigation]').forEach(form=>{if(form.dataset.wired)return;form.dataset.wired='true';form.querySelector('select').addEventListener('change',()=>form.requestSubmit());});
root.querySelectorAll('.menu-toggle').forEach(button=>{if(button.dataset.wired)return;button.dataset.wired='true';button.addEventListener('click',()=>{const nav=document.getElementById('main-nav');const open=button.getAttribute('aria-expanded')!=='true';button.setAttribute('aria-expanded',String(open));nav?.classList.toggle('open',open);});});
root.querySelectorAll('[data-contact-type]').forEach(button=>{if(button.dataset.wired)return;button.dataset.wired='true';button.addEventListener('click',()=>{const select=document.getElementById('contact-enquiry-type');if(select)select.value=button.dataset.contactType;document.querySelectorAll('[data-contact-type]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));});});window.fsNativeRewriteLinks?.(root);
};
const learn=root=>{
root.querySelectorAll('[data-native-learn]').forEach(panel=>{
if(panel.dataset.wired)return;
panel.dataset.wired='true';
const search=panel.querySelector('[data-native-search]');
const product=panel.querySelector('[data-native-product-filter]');
const buttons=[...panel.querySelectorAll('[data-native-type]')];
const count=panel.querySelector('[data-native-result-count]');
const grid=panel.querySelector('.fs-learn-grid');
const status=panel.querySelector('[data-native-load-status]');
const pagination=panel.querySelector('[data-native-pagination]');
const retry=panel.querySelector('[data-native-retry]');
let cards=[...panel.querySelectorAll('[data-native-resource]')];
let category='all';
const paint=()=>{
  const terms=search.value.toLowerCase().trim().split(/\s+/).filter(Boolean);
  const allowed=cards.filter(card=>(product.value==='all'||(card.dataset.products||'').split(',').map(value=>value.trim()).includes(product.value))&&terms.every(term=>(card.dataset.search||'').toLowerCase().includes(term)));
  const matching=new Set(allowed);
  let found=0;
  cards.forEach(card=>{const show=matching.has(card)&&(category==='all'||card.dataset.category===category);card.hidden=!show;if(show)found++;});
  buttons.forEach(button=>{button.setAttribute('aria-pressed',String(button.dataset.nativeType===category));button.querySelector('[data-native-count]').textContent=allowed.filter(card=>button.dataset.nativeType==='all'||card.dataset.category===button.dataset.nativeType).length;});
  count.textContent=count.dataset.label.replace('__COUNT__',found);
};
buttons.forEach(button=>button.addEventListener('click',()=>{category=button.dataset.nativeType;paint();}));
search.addEventListener('input',paint);
product.addEventListener('change',paint);
panel.querySelector('[data-native-reset]').addEventListener('click',()=>{category='all';search.value='';product.value='all';paint();});
paint();
const total=Number(panel.dataset.nativePageCount)||1;
const loaded=new Set([Number(panel.dataset.nativeCurrentPage)||1]);
const handles=new Set(cards.map(card=>card.dataset.nativeHandle).filter(Boolean));
let loading=false;
const load=async()=>{
  if(loading||loaded.size>=total||!pagination)return;
  loading=true;
  status.hidden=false;
  status.textContent=status.dataset.loadingLabel;
  grid.setAttribute('aria-busy','true');
  if(retry)retry.hidden=true;
  try{
    for(let number=1;number<=total;number++){
      if(loaded.has(number))continue;
      if(!panel.isConnected)return;
      const url=new URL(window.location.href);
      url.searchParams.delete('sections');
      url.searchParams.set('section_id',panel.dataset.nativeSection);
      url.searchParams.set(panel.dataset.nativePageParam||'page',String(number));
      const response=await fetch(url.toString(),{credentials:'same-origin',signal:AbortSignal.timeout(20000)});
      if(!response.ok)throw new Error('Guide page request failed');
      const documentPage=new DOMParser().parseFromString(await response.text(),'text/html');
      const incoming=documentPage.querySelector('[data-native-learn]');
      if(!incoming||Number(incoming.dataset.nativeCurrentPage)!==number)throw new Error('Guide page response was incomplete');
      incoming.querySelectorAll('[data-native-auto]').forEach(card=>{
        if(!handles.has(card.dataset.nativeHandle)){
          handles.add(card.dataset.nativeHandle);
          grid.appendChild(document.importNode(card,true));
        }
      });
      loaded.add(number);
    }
    pagination.hidden=true;
    status.hidden=true;
    panel.dataset.nativeIndexComplete='true';
  }catch(error){
    status.textContent=status.dataset.errorLabel;
    pagination.hidden=false;
    if(retry)retry.hidden=false;
  }finally{
    const automatic=[...grid.querySelectorAll('[data-native-auto]')];
    automatic.sort((a,b)=>Number(b.dataset.published)-Number(a.dataset.published)||(a.dataset.nativeHandle||'').localeCompare(b.dataset.nativeHandle||''));
    automatic.forEach(card=>grid.appendChild(card));
    cards=[...grid.querySelectorAll('[data-native-resource]')];
    window.fsNativeRewriteLinks?.(panel);
    paint();
    grid.setAttribute('aria-busy','false');
    loading=false;
  }
};
if(retry)retry.addEventListener('click',load);
if(total>1)load();else panel.dataset.nativeIndexComplete='true';
});};
const refresh=()=>{if(typeof initHome==='function'){routeCleanup();initHome();}wire(document);learn(document);};
refresh();
document.addEventListener('shopify:section:load',refresh);
document.addEventListener('shopify:section:reorder',refresh);
document.addEventListener('shopify:section:unload',()=>{if(typeof routeCleanup==='function')routeCleanup();});
document.addEventListener('shopify:block:select',e=>e.target.scrollIntoView({block:'nearest',inline:'center'}));
document.addEventListener('keydown',e=>{if(e.key==='Escape'){document.querySelector('.nav')?.classList.remove('open');document.querySelector('.menu-toggle')?.setAttribute('aria-expanded','false');}});
})();

(()=>{
const frameSelector='.cf-compare,.sf-compare,.fs-compare,.lbc-compare,.soil-comparison';
const labelSelector='.cf-label,.sf-label,.fs-glass-label,.lbc-glass-label,.comparison-label,.comparison-tag,[data-compare-label]';
const wired=new WeakSet();
function initComparisonLabels(root){
const frames=[...(root.matches?.(frameSelector)?[root]:[]),...root.querySelectorAll(frameSelector)];
frames.forEach(frame=>{
if(wired.has(frame))return;
const labels=[...frame.querySelectorAll(labelSelector)];
if(labels.length!==2)return;
wired.add(frame);
const update=()=>{
const bounds=frame.getBoundingClientRect();
if(!bounds.width)return;
const style=getComputedStyle(frame),range=frame.querySelector('input[type=range]');
const value=parseFloat(style.getPropertyValue('--split')||style.getPropertyValue('--reveal')||range?.value||'50');
const split=bounds.left+bounds.width*Math.max(0,Math.min(100,value))/100;
const scale=bounds.width/(frame.offsetWidth||bounds.width);
labels.forEach((label,index)=>{
const rect=label.getBoundingClientRect();
const left=index===1?Math.max(0,Math.min(rect.width,split-rect.left))/scale:0;
const right=index===0?Math.max(0,Math.min(rect.width,rect.right-split))/scale:0;
label.style.clipPath='inset(0 '+right+'px 0 '+left+'px)';
label.setAttribute('aria-hidden',String(index===0?split<=rect.left:split>=rect.right));
});
};
frame.addEventListener('input',()=>requestAnimationFrame(update));
new MutationObserver(update).observe(frame,{attributes:true,attributeFilter:['style']});
const resize=new ResizeObserver(update);resize.observe(frame);labels.forEach(label=>resize.observe(label));
update();
});
}
initComparisonLabels(document);
document.addEventListener('shopify:section:load',event=>initComparisonLabels(event.target));
new MutationObserver(records=>records.forEach(record=>record.addedNodes.forEach(node=>{if(node.nodeType===1)initComparisonLabels(node);}))).observe(document.body,{childList:true,subtree:true});
})();


(()=>{
  const palette=['#0A7968','#D6FF5F','#020803','#4B73AD','#C05235'];
  const pending=new WeakSet(),releasing=new WeakSet();
  let cleanup=()=>{};
  function burst(button){
    cleanup();
    if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    const rect=button.getBoundingClientRect(),canvas=document.createElement('canvas');
    canvas.setAttribute('aria-hidden','true');
    canvas.style.cssText='position:fixed;inset:0;width:100vw;height:100vh;pointer-events:none;z-index:2147483647';
    document.body.appendChild(canvas);
    const ctx=canvas.getContext('2d');
    if(!ctx){canvas.remove();return;}
    const w=innerWidth,h=innerHeight,dpr=Math.min(devicePixelRatio||1,2);
    canvas.width=w*dpr;canvas.height=h*dpr;ctx.scale(dpr,dpr);
    const x=Math.max(0,Math.min(w,rect.left+rect.width/2));
    const y=Math.max(0,Math.min(h,rect.top+rect.height/2));
    const particles=Array.from({length:w<600?300:520},(_,i)=>{
      const angle=-Math.PI+Math.random()*Math.PI;
      const speed=Math.max(w,h)*(0.7+Math.random()*1.1);
      return {x:x+(Math.random()-.5)*rect.width,y,vx:Math.cos(angle)*speed,vy:Math.sin(angle)*speed-120,size:5+Math.random()*8,angle:Math.random()*Math.PI,spin:(Math.random()-.5)*12,phase:Math.random()*Math.PI*2,color:palette[i%palette.length]};
    });
    let frame,start=performance.now(),last=start,removed=false;
    cleanup=()=>{removed=true;cancelAnimationFrame(frame);canvas.remove();};
    function draw(now){
      if(removed)return;
      const dt=Math.min((now-last)/1000,.035),age=(now-start)/1000;last=now;
      ctx.clearRect(0,0,w,h);
      for(const p of particles){
        p.vx*=Math.exp(-2.1*dt);p.vy+=550*dt;
        p.x+=p.vx*dt+Math.sin(age*5+p.phase)*28*dt;p.y+=p.vy*dt;
        p.angle+=p.spin*dt;
        ctx.save();ctx.globalAlpha=Math.min(1,(4.5-age)/.8);ctx.translate(p.x,p.y);ctx.rotate(p.angle);
        ctx.fillStyle=p.color;ctx.scale(1,Math.cos(age*9+p.phase)*.7+.3);
        ctx.fillRect(-p.size/2,-p.size/3,p.size,p.size*.65);ctx.restore();
      }
      if(age<4.5)frame=requestAnimationFrame(draw);else cleanup();
    }
    frame=requestAnimationFrame(draw);
  }
  document.addEventListener('submit',event=>{
    const form=event.target,button=event.submitter;
    if(!button||releasing.has(form))return;
    const isCartAdd=button.matches('[name="add"]')||(/\/cart\/add(?:\.js)?\/?$/.test(new URL(form.action,location.href).pathname));
    if(!button.matches('.fs-buy-now')&&!isCartAdd)return;
    event.preventDefault();event.stopImmediatePropagation();
    if(pending.has(form))return;
    pending.add(form);form.setAttribute('aria-busy','true');
    burst(button);
    setTimeout(()=>{
      pending.delete(form);form.removeAttribute('aria-busy');
      if(!form.isConnected||!button.isConnected)return;
      releasing.add(form);
      try{form.requestSubmit(button);}finally{releasing.delete(form);}
    },matchMedia('(prefers-reduced-motion: reduce)').matches?0:650);
  },true);
  document.addEventListener('click',event=>{
    const button=event.target.closest('button,a,[role="button"],input[type="button"]');
    if(!button||button.disabled||button.getAttribute('aria-disabled')==='true')return;
    const label=(button.getAttribute('aria-label')||button.value||button.textContent||'').trim().replace(/\s+/g,' ');
    if(!/^add to (cart|bag|basket)\b/i.test(label))return;
    if(button.form&&button.type==='submit')return;
    burst(button);
  },true);
  addEventListener('pagehide',()=>cleanup());
})();
